import { http, HttpResponse } from 'msw';
import { mockClaims } from './claimMock';
import { Claim } from 'interfaces';

interface FiltersResponse {
  createdAt?: { startDate: string; endDate: string };
}
const extractFilters = (filters: string): FiltersResponse => {
  const response: FiltersResponse = {};
  if (filters.includes('createdAt')) {
    const [startDate, endDate] = filters.split('createdAt:')[1].split(',');
    response['createdAt'] = { startDate, endDate };
  }
  return response;
};

const applyFilters = (
  filters: FiltersResponse,
  siteID: string = '',
  tariffStatus: string = ''
) => {
  return mockClaims.filter((claim: Claim) => {
    const filterConditions: { [key: string]: boolean } = {
      siteID: siteID ? claim.siteID === siteID : true,
      tariffStatus:
        !tariffStatus ||
        claim.tariffs.some((tariff) => tariff.status === tariffStatus),

      createdAt: filters.createdAt
        ? claim.createdAt >= filters.createdAt.startDate &&
          claim.createdAt <= filters.createdAt.endDate
        : true,
    };

    return Object.values(filterConditions).every(Boolean);
  });
};

export const mockDashboardData = {
  // === New Provider Dashboard Metrics (tutorial mode fallback) ===
  allTimeOutstanding: {
    public: 250,
    'third-party': 60,
    direct: 25,
    'all-time-start': '2025-01-01',
  },
  dateBasis: 'billed-date',
  summaryMode: 'pay-period',
  ytdPaidAmount: 5000,
  ytdSubmittedAmount: 6000,
  ytdWrittenOffAmount: 700,
  ytdStartDate: '2025-01-01',
  ytdEndDate: '2025-10-30',
  ytdPrivatePaidAmount: 2200,
  ytdPrivateSubmittedAmount: 2600,
  ytdPrivateWrittenOffAmount: 150,
  ytdDirectPaidAmount: 300,
  ytdDirectSubmittedAmount: 450,
  ytdDirectWrittenOffAmount: 25,
  currentSummaryPaidAmount: 400,
  currentSummarySubmittedAmount: 900,
  currentSummaryWrittenOffAmount: 50,
  currentSummaryLastActivity: '2025-10-30',
  currentSummaryPeriodStart: '2025-10-16',
  currentSummaryPeriodEnd: '2025-10-30',
  lastSummaryPaidAmount: 1100,
  lastSummarySubmittedAmount: 1000,
  lastSummaryWrittenOffAmount: 120,
  lastSummaryPeriodStart: '2025-10-01',
  lastSummaryPeriodEnd: '2025-10-15',
  currentPayPeriodPaidAmount: 400,
  currentPayPeriodSubmittedAmount: 900,
  currentPayPeriodWrittenOffAmount: 50,
  currentMonthPaidAmount: 950,
  currentMonthSubmittedAmount: 1400,
  currentMonthWrittenOffAmount: 70,
  lastPayPeriodSubmittedAmount: 1000,
  lastPayPeriodPaidAmount: 1100,
  lastPayPeriodWrittenOffAmount: 120,
  lastMonthPaidAmount: 1800,
  lastMonthSubmittedAmount: 2100,
  lastMonthWrittenOffAmount: 45,
};

export const mockDashboardHandlers = [
  http.get('*/resource/claim/organization', ({ request }) => {
    const url = new URL(request.url).searchParams;
    const sites = url.get('sites');
    const startDate = url.get('startDate');
    const endDate = url.get('endDate');
    return HttpResponse.json(
      mockClaims.filter(
        (claim: Claim) =>
          claim.siteID === sites &&
          claim.createdAt >= startDate &&
          claim.createdAt <= endDate
      )
    );
  }),
  http.get('*/resource/claim/site/status/count', ({ request }) => {
    const url = new URL(request.url).searchParams;
    const siteID = url.get('siteID');
    const tariffStatus = url.get('tariffStatus');
    const filters = url.get('filters');
    const response = applyFilters(
      extractFilters(filters),
      siteID,
      tariffStatus
    );
    return HttpResponse.json(response);
  }),
];
